import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle'
import {Helmet} from 'react-helmet';
import './eooDamageReportingPage.scss';

/**
 * The EooDamageReportingPage component.
 *
 * @constructor
 */
export class EooDamageReportingPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="eoo-damage-reporting-page" className="system-page">
        <div className="container">
          <Helmet>
            <title>Utility Leak Damage Reporting - NEI</title>
            <meta name = "description" content ="Any damage to a buried facility, even if it appears minor, must be reported right away." />
          </Helmet>
          <div className="row">
            <div className="col">
              <h1>Any damage to a buried facility must be reported.</h1>
              <h3>If an underground utility or pipeline is damaged in any way:</h3>
              <ul>
                <li>Immediately stop work and leave the scene</li>
                <li>Report it to the utility owner or pipeline operator</li>
              </ul>
              <h3>If a confirmed or suspected product release occurs:</h3>
              <ul>
                <li>Leave the scene in an upwind or crosswind direction</li>
                <li>When in a safe area, call 911</li>
                <li>Then call the utility owner or pipeline operator and 811</li>
              </ul>
              <p><strong>Reminder:</strong> Any damage, even if it appears to be minor, including a gouge, scrape, dent, or crease – could potentially affect integrity and produce a future pipeline leak or disruption in service.</p>
            </div>
          </div>
          <div className="row">
          </div>
        </div>
      </div>
    );
  }
}

EooDamageReportingPage.propTypes = {};

export default EooDamageReportingPage;



// WEBPACK FOOTER //
// ./src/components/pages/eooDamageReporting/EooDamageReportingPage.js